/**
 * Created by jehe on 07.02.2019.
 */
/*global define, require, $, window, ol*/

/*jslint browser: true*/

import attribution from "./js/plugins/attributionPlugin";
import layermenu from "./js/plugins/layermenuPlugin";
import baselayerSwitcher from "./js/plugins/baselayerSwitcherPlugin";
import searchPlugin from "./js/plugins/searchPlugin";
import topMenuPlugin from "./topMenuToolsPlugin";
import mapWriterPlugin from "./js/plugins/mapWriterPlugin";
import layerspyPlugin from "./js/plugins/layerspyPlugin";
import layerSliderPlugin from "./js/plugins/layerSliderPlugin";
import mapTools from  "./js/plugins/mapToolPlugin.js";
import solkartPlugin from "./solkartPlugin";

"use strict";
var parameters, configs;
//var baseUrl = "//10.192.10.26/";
var	baseUrl = "https://od2.pbe.oslo.kommune.no/";
var	extraUrl = "https://od2.pbe.oslo.kommune.no/";
parameters = {
	intranett: true,
	wfsTillegg: "&version=1.1.0&service=wfs&request=GetFeature",
	/** Kart-url'er */
	cacheurl: baseUrl + "tilecache",
	//phpAutocomplete: baseUrl + "php/kartinnsyn/",
	phpAutocomplete: baseUrl + "kartinnsyn/",
	//autocompleteUrl: baseUrl + "php/kartinnsyn/getAutocompleteData.php",
	autocompleteUrl: baseUrl + "kartinnsyn/getAutocompleteData.php",
	searchUrl: baseUrl + "cgi-bin/wms?map=WFS_SOK",
	kartinnsynurl: baseUrl + "cgi-bin/wms?map=KARTINNSYN",
	//geoJsonWFS: baseUrl + "cgi-bin/wms?map=PIGEOJSON",
	geoJsonWFS: baseUrl + "cgi-bin/wms?map=PI4_GEOJSON",
	tableWfs: baseUrl + "cgi-bin/wms?map=EIENDOM_TABELL&tabell=",
	mapcacheurl: baseUrl + "mapcache/wmts?",
	vannBekkerEleverurl: baseUrl + "cgi-bin/wms?map=VANN_NY",
	flyfotoUrl: baseUrl + "/cgi-bin/wms?map=SOMMERFOTO",
	flyfotoTextUrl: baseUrl + "cgi-bin/wms?map=TEKST_FLYFOTO",
	planmetaWSUrl: "https://od2.pbe.oslo.kommune.no:8443/Planmetadata/planmetadata?",
	bakgrunnGraaUrl: baseUrl + "cgi-bin/wms?map=BAKGRUNN",
	solkartUrl: "https://od2.pbe.oslo.kommune.no/cgi-bin/mapserv.exe?map=d:/data_mapserver/kartfiler/solkart.map",
	gullisteUrl: baseUrl + "cgi-bin/wms?map=GULLISTE",
},
configs = {
	minZoom: 11,
	mapTools: [
	//Måle areal
		{
			id: "measure-area-small",
			className: "area-btn measure-btn",
			toolTip: "Mål areal",
			buttonText: "Mål areal",
			iconType: "text",
			icon: "m²",
			onclick: "measureAreaClick",
			register: function(registerFunction, callback){
				mapTools.registerAreaMeasurePlugin(registerFunction, callback);
			},
			toolHelp: {
				header: "Slik måler du",
				id: "measure-area-small-tool-help",
				steps: [
					"Klikk i kartet for plassere punktene du skal måle mellom.",
					"Dobbelklikk når du plasserer siste punkt for å fullføre en måling.",
					'Slett målingene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
				],
			}
		},
//Måle lengde
		{
			id: "measure-length-small",
			className: "length-btn measure-btn",
			toolTip: "Mål avstand",
			buttonText: "Mål avstand",
			iconType: "icon",
			icon: "icon-measure",
			onclick: "measureLengthClick",
			register: function(registerFunction, callback){
				mapTools.registerLengthMeasurePlugin(registerFunction, callback);
			},
			toolHelp: {
				header: "Slik måler du",
				id: "measure-length-small-tool-help",
				steps: [
					"Klikk i kartet for plassere punktene du skal måle mellom.",
					"Dobbelklikk når du plasserer siste punkt for å fullføre en måling.",
					'Slett målingene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
				],
			}
		},
//Tegne
		{
			id: "make-sketch-small",
			className: "sketch-btn",
			toolTip: "Lag tegninger",
			buttonText: "Lag tegninger",
			iconType: "icon",
			icon: "fa fa-pencil",
			onclick: "drawClick",
			register: function(registerFunction, callback){
				mapTools.registerDrawPlugin(registerFunction, callback);
			},
			toolHelp: {
				header: "Slik tegner du",
				id: "make-sketch-small-tool-help",
				steps: [
					"Klikk i kartet for plassere punktene i tegningen.",
					"Dobbelklikk når du plasserer siste punkt for å fullføre en tegning.",
					'Slett tegningene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
				],
			}
		},
//Zoom helt ut
		{
			id: "zoom-full-small",
			className: "map-eraser-btn",
			toolTip: "Zoom til hele Oslo",
			buttonText: "Zoom helt ut",
			iconType: "icon",
			icon: "glyphicon glyphicon-globe",
			onclick: "zoomFullClick",
		},
//Fjern markeringer
		{
			id: "map-eraser-small",
			className: "map-eraser-btn",
			toolTip: "Fjern markeringer av eiendommer og planer i kartet",
			buttonText: "Fjern markeringer",
			iconType: "icon",
			icon: "glyphicon glyphicon-erase",
			onclick: "eraserClick",
		},
		{
			id: "layer-spy",
			className: "point-search-btn",
			toolTip: "Se på underliggende kartlag med kikkehullet",
			buttonText: "Kikkehull",
			iconType: "icon",
			icon: "icon-Kikkehull",
			touchSensitive: true,
			onclick: "spyClick",
			parameters:"flyfoto",
			register: function(registerFunction, callback){
				layerspyPlugin.registerPluginFunction(registerFunction, callback);
			},				
			toolHelp: {
				header: "Kikkehull",
				id: "layer-spy-tool-help",
				steps: [
					"Bruk musepekeren til å se på flyfoto under kartet.",
					"Bruk piltast opp eller ned for å gjøre kikkehullet større eller mindre",
				],
			}
		},
		{
			id: "layer-slider",
			className:  "slider-btn",
			toolTip: "Bruk slideren til å skjule deler av kartlaget eller gjøre det mer gjennomsiktig.",
			buttonText: "Slide",
			iconType: "icon",
			icon: "fa fa-sliders",
			onclick: "mapSliderClick",
			register: function(registerFunction, callback){
				layerSliderPlugin.registerPluginFunction(registerFunction, callback);
			},
		}
	],
	topMenu: [
			{
				type: "button",
				id: "planinnsyn-hjelp",
				toolTip: "Åpner hjelpemeny.",
				icon: true,
				iconClass: "icon-Menu",
				innerHTML: "<div class='textHider'>Om tjenesten<div>",
				onclick: function () {
					$("#share-page").hide(250);
					$("#help-page").toggle(250);
					$(".show-collapsible").removeClass("show-collapsible");
					$("#planinnsyn-hjelp").toggleClass("drop-down-row-active");
					$("#planinnsyn-hjelp").find("i").toggleClass("icon-Menu").toggleClass("icon-Close");
				},
				contentPage: "helpMenu",
			},{
				type: "button",
				id: "planinnsyn-del",
				toolTip: "Del siden, eller lag bokmerke/snarvei.",
				icon: true,
				iconClass: "icon-Del",
				innerHTML: "Del",
				onclick: "shareClick",
				contentPage: "sharePage",
			}
		],
	baseLayers: [
		{
			olType: "group",
			layerId: "baselayers",
			displayInLayerMenu: false,
			layers: [
				{
					olType: "wmts",
					title: "Bakgrunnskart",
					layerId: "bakgrunn",
					url: parameters.mapcacheurl,
					layerName: "bakgrunn_graa",
					visible: false,
					displayInLayerMenu: false,
					altSource: {
						url: parameters.bakgrunnGraaUrl,
						layerName: "bakgrunn_graa"
					}
				}, {
					olType: "wmts",
					layerId: "flyfoto",
					title: "Flyfoto",
					url: parameters.mapcacheurl,
					layerName: "sommerfoto",
					dependent: "text2",
					altSource: {
						url: parameters.flyfotoUrl,
						layerName: "nyeste_flyfoto_bg_hvit",
						epsg: "EPSG:32632"
					},
					displayInLayerMenu: false,
					visible: false
				},{
					olType: "image",
					title: "Gatenavn, adresser, m.m (flyfoto)",
					layerId: "text2",
					url: parameters.flyfotoTextUrl,
					layerName: "forgrunn_tekst",
					zIndex: 100,
					displayInLayerMenu: false,
					visible: false
				},{
					olType: "image",
					title: "Tiltaksflater",
					layerId: "tiltaksflate",
					url: parameters.ki_forgrunnurl,
					zIndex: 200,
					layerName: "Tiltaksflate",
					displayInLayerMenu: false,
					noToggle: true,
					visible: true
				}
			]
		}
	], 
	layermenuLayers: [
		{
			olType: "image",
			layerId: "sol",
			title: "Solinnstråling",
			url: parameters.solkartUrl,
			layerName: "sol2023",
			displayInLayerMenu: true,
			legend: "tegnforklaring.png",
			visible: true
		},
		{
			olType: "image",
			layerId: "takflater",
			title: "Takflater",
			url: parameters.solkartUrl,
			layerName: "takflater2024",
			displayInLayerMenu: true,
			visible: true
		},
		{
			olType: "group",
			title: "Gul liste <span class='layer-title-small'>(kulturminner med eller uten formelt vern)</span>",
			layerId: "gulliste",
			layerInfo: true,
			groupCheckbox: true,
			visible: false,
			attribution: "©Byantikvaren",
			attributionId: "c-bya",
			layers: [
				{
					olType: "tile",
					title: "Kulturmiljø",
					layerId: "gl_kulturmiljo",
					url: parameters.gullisteUrl,
					layerName: "Kulturmiljo",
					visible: false
				}, {
					olType: "tile",
					title: "Sikringssone",
					layerId: "gl_sikringssone",
					url: parameters.gullisteUrl,
					layerName: "Sikringssone",
					visible: false
				}, {
					olType: "tile",
					title: "Lokaliteter",
					layerId: "gl_lokaliteter",
					url: parameters.gullisteUrl,
					layerName: "Lokaliteter",
					visible: false
				}, {
					olType: "tile",
					title: "Kulturminner",
					layerId: "gl_kulturminne",
					url: parameters.gullisteUrl,
					layerName: "Enkeltminner",
					visible: false
				}
			]
		},
	],
	fkbLayers: false,
	//quickSearch: true,//Legger til hurtigvalgsmeny på toppen av kartlagsmenyen. Modes under med displayname vises i nedtreksmenyen.
	modes: [
		{mode: "saksinnsyn", displayName: "Saksinnsyn", layers: ["byggesak"]},
		{mode: "kommuneplan", displayName: "Kommuneplan", layers: ["kp"]},
		{mode: "kpt1", layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_stoy"]},
		{mode: "kpt2", layers: ["kp", "kp_pk1_2", "kp_tema_ikke_juridisk_luftforurensing_t2"]},
		{mode: "kpt3", layers: ["kp", "kp_pk1_2", "kp_tema_ikke_juridisk_luftforurensing_t3"]},
		{mode: "kpt4", layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_naturmiljo"]},
		{mode: "kpt5", layers: ["kp", "kp_pk1_2", "kp_tema_ikke_juridisk_kulturminnevern"]},
		{mode: "kpt6", layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_storulykke"]},
		{mode: "kpt7", layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_blaagronn_struktur"]},
		{mode: "kp2-2", layers: ["kp", "kp_pk1_2", "kp_pk2_2"]},
		{mode: "gulliste", displayName: "Gul liste", layers: ["gulliste"]},
		{mode: "drenering", displayName: "Drenering", layers: ["drenering"]},
		{mode: "smahusplanen", displayName: "Småhusplanen", layers: ["smahusplanen"]},
		{mode: "vann", displayName: "Vann", layers: ["vann"]},
		{mode: "kdp",  displayName: "Kommunedelplaner", layers: ["kdp"]},
		{mode: "eiendom", displayName: "Eiendom", layers: ["eiendom"]},
		{mode: "blagronn", displayName: "Blågrønn faktor", layers: ["blagronn_faktor", "eiendom"]},
		{mode: "planprogramogvpor", displayName: "Planprogram og vpor", layers: ["planprogram", "vpor", "vporpaagaaende", "planprogrampaagaaende"]},
		{mode: "reklame", displayName: "Reklame", layers: ["reklameomrader"]},
		{mode: "mft", displayName: "Midlertidig forbud mot tiltak.", layers: ["MFT"]},
		{mode: "forurensetgrunn", displayName: "Forurenset grunn", layers: ["forurenset_grunn"]}
	],
	search: {
		autocompleteUrl:  parameters.autocompleteUrl,
		autocompleteHandlers: [{key: "gate", func: "lookupAdresserForGate"}, {key: "plan", func: "getLookupPlan"}, {key: "stedsnavn", func: "getLookupStedsnavn"}],
		ariaLabel: "Skriv inn adresse, gårds- og bruksnummer, plannummer eller saksnummer",
		placeholder: "Søk på adresse, gnr./bnr., plannr. eller saksnr."
	},
	mapInteractions: {
		featureHover: true,
		featureClick: true
	},
	contextMenu: {
		active: true,
		title1: "Om valgt eiendom",
		title2: "Om valgt punkt",
		mode: {
			top: true,
			area: true,
			point: false,
			/*bottom: "Hva vil du gjøre?",*/
		},
		headerField: {
	
		},
		bottomField: {
	
		},
		//Felter til kontekstmenyen.
		fields: [
			{
				id: "soldataParent",
				title: "Solinnstråling",
				fields: [
					{
						id: "takflater",
						title: "Takflater",
						point: true,
					}
				],
			},
		],
		loaders: [{
				loaderType: "WFS",
				service: parameters.solkartUrl,	
				table: "takflater2023",
				typeNames: ["takflater2023"],
				filterItem: ["teigid"],
				targets:[
					{
						id: "takflater",
						layerId: "sol",
						showExtendedInfo: true,
						comparator: "header",
						layout: [
							{type: "header", value: "header", unique: true},
							{type: "layerCheckbox", tekst: "Vis i kartet", unique: true},
							//{type: "legendFeature", legendValue: "legendValues", labelValue: "labelValues", hover: true, triggerField: true},
							{type: "conditional", notEmptyCondition: "tester", 
								exist: {type: "legendFeature", legendValue: "legendValues", labelValue: "labelValues", hover: true, triggerField: true},
								"":   {type: "legendFeature", legendValue: "legendValues", labelValue: "labelValues", hover: true, triggerField: false},
							},
							
						],
						values: {
							legendValues: ["KODE"],
							labelValues: ["KODE_TEKST"], 
							header: "TEMAGRUPPE", 
							layerCheckbox: "TEMAGRUPPEKODE", 
							comparator: "KODE_TEKST",
							counter: "KODE",
							key: "KODE",
							tester: "OM_BESK",
						},
						extendedInfo: {
							//header: "Kommuneplan",
							//internal: "./kp_extended_info",
							layout: [
									{type: "header4", value: "LABEL"}, // går det an å få denne teksten større?
									{type: "paragraph", prefix: "<strong>Beskrivelse</strong><br />", value: "OM_BESK"},
									{type: "paragraph", prefix: "<strong>Begrunnelse</strong><br />", value: "OM_BEGR"},
									]
						}
					}
				]						
			},
		],
		dyplenker: [
		],
		//Layout for klikk på features i kartet. 
		//Info kommer fra WFS
		featureClickLayout:{
			
		},			
	},
	//Tipsboks. TipId settes som cookie for å ikke vise boksen igjen.
	activeTip: false,
	tipText: "Her kommer det noe vettug tekst, kanskje<br /><br /> Klikk i kartet og se under «Kommuneplan 2024» for å få mer informasjon om kartobjektene",
	tipId: "testWarning",
};

// Legg til ekstra css-filer
//$("head").append("<link rel='stylesheet' type='text/css' href='css/foo.css'>");

//Titlelink setter lenke for oslologo + planinnsyn. Går til seg selv hvis den ikke er satt.
export default {
	intranett: true,
	site: {
		title: 'Solkart',
		titleLink: ""
	},
	loadplugins: function (map, callback){
		attribution.initiate(
			{
				parent : "footerId", 
				id :"copy-pbe", 
				text :"©Oslo PBE"
			}
		);
		layermenu.initiate(configs.layermenuLayers, "Velg kartlag");
		baselayerSwitcher.initiate(document.getElementById("mapmenu"), map, "bakgrunn", "flyfoto", worldPath + "img/bakgrunnskart.min.png", worldPath + "img/flyfoto.min.jpg");
		searchPlugin.initiate(configs.search);
		solkartPlugin.initiate(configs);
		topMenuPlugin.initiate(configs.topMenu, parameters.intranett);
		callback();
	},
	customClickTriggers: [],
	parameters: parameters,
	configs: configs,
};
